import { minLength, maxLength, stringPattern, stringPatternError } from '../../utils/form-validations';

export const ontologySchema = {
  type: 'array',
  items: [
    {
      type: 'object',
      properties: {
        level_name: {
          type: 'string',
          minLength,
          maxLength,
          // pattern: stringPattern,
          // errorMessage: {
          //   pattern: stringPatternError,
          // },
        },
        level_number: { type: 'number' },
      },
      required: ['level_name'],
      additionalProperties: true,
    },
  ],
};

// Add Level
export const addLevelUISchema = [
  {
    id: 1,
    label: 'Name',
    name: 'onto_manage_title',
  },
];

export const addLevelSchema = {
  type: 'object',
  properties: {
    onto_manage_title: {
      type: 'string',
      minLength,
      maxLength,
      // pattern: stringPattern,
      // errorMessage: {
      //   pattern: stringPatternError,
      // },
    },
  },
  required: ['onto_manage_title'],
  additionalProperties: true,
};
